import React from "react";
import styled from "styled-components";

// Assets
import CloseIcon from "../../assets/svg/CloseIcon";
import LogoImage from "../../../../images/custom/logo.png";
// import IsoImage from "../../../../images/custom/iso.png";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <Img
            className="radius8"
            src={LogoImage}
            alt="office"
            style={{ zIndex: 9 }}
          />
          <h1 style={{ marginLeft: "15px" }} className="comfortaa-logo">
            Tu Taller
          </h1>
          {/* <Img className="" src={IsoImage} alt="Tu Taller" style={{ zIndex: 9 }} /> */}
        </div>
        <CloseBtn
          onClick={() => toggleSidebar(!sidebarOpen)}
          className="animate pointer"
        >
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            href="/home"
          >
            Home
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            href="/home#services"
          >
            Funcionalidades
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            href="/home#screenshots"
          >
            La App
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            href="/home#pricing"
          >
            Precio
          </Link>
        </li>
        <li className="semiBold font15 pointer">
          <Link
            onClick={() => toggleSidebar(!sidebarOpen)}
            activeClass="active"
            className="whiteColor"
            style={{ padding: "10px 15px" }}
            href="/home#contact"
          >
            Contactanos
          </Link>
        </li>
        <li className="semiBold font15 pointer flexCenter">
          <a href="https://blog.tutaller.com.ar" target="_blank" rel="noreferrer" className="radius8 whiteColor" 
            style={{ padding: "10px 15px", backgroundColor: "transparent", border: "1px solid white" }}>
            Blog
          </a>
        </li>
      </UlStyle>
      <UlStyle>
        <li className="semiBold font15 pointer flexCenter">
          <a
            href="/home/create"
            className="radius8 wc-bg-secondary"
            style={{
              padding: "10px 15px",
              color: "white",
              pointerEvents: "none",
            }}
          >
            Creá tu espacio
          </a>
        </li>
      </UlStyle>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 30px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-400px")};
  z-index: 9999;
  @media (max-width: 400px) {
    width: 100%;
  }
  @media (min-width: 760px) {
    width: 0em;
  }
`;
const SidebarHeader = styled.div`
  padding: 20px 0;
`;
const CloseBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;
  padding: 10px;
`;
const UlStyle = styled.ul`
  padding: 40px;
  li {
    margin: 20px 0;
  }
`;

const Img = styled.img`
  max-width: 4.5em;
  @media (max-width: 560px) {
    width: 80%;
    height: auto;
  }
`;

const Link = styled.a``;
